import { AuthModel } from '@/models/UserModel';

export interface UserState {
  auth: AuthModel | null;
}

const state: UserState = {
  auth: null,
};

export default state;
